<template>
  <LoginLayout>
    <div class="login-new-page-login-container">
      <img :src="cnLogo" alt="thecn.com" class="cn-logo" />
      <div class="login-new-page-login">
        <CoverImage />
        <FormLogin>
          <h2 class="institution-heading">{{ heading }}</h2>
        </FormLogin>
      </div>
    </div>
  </LoginLayout>
</template>

<script>
import LoginLayout from "@/components/layouts/LoginNew.vue";
import FormLogin from "@/components/forms/Login.vue";
import CoverImage from "@/components/users/cover-image.vue";

import { mapState } from "vuex";

export default {
  components: {
    LoginLayout,
    CoverImage,
    FormLogin,
  },
  data() {
    return {
      cnLogo: require("@/assets/img/cn_logo2.png"),
      screenShots: [
        require("@/assets/img/screen_shot.png"),
        require("@/assets/img/screenshot2.png"),
        require("@/assets/img/screenshot3.jpg"),
      ],
    };
  },
  computed: {
    ...mapState("siteBrand", ["links", "heading"]),
  },
};
</script>

<style scoped lang="scss">
.login-new-page {
  &-login-container {
    .cn-logo {
      display: none;
    }
    @media all and (max-width: 768px) {
      .cn-logo {
        display: inline-block;
        margin: rem(20) rem(15) rem(10) rem(15);
      }
    }
  }
  &-login {
    padding: rem(40);

    @media all and (max-width: 768px) {
      box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.07);
      border-radius: 12px;
      margin: rem(15);
      padding: rem(0);

      .form-login {
        padding: rem(15);
      }
    }
  }
}
</style>
